module.exports = __webpack_public_path__ + "img/lanzi.05d06974.png";